import * as Types from '../constants/Types';

export const dataRoleAction = (filters) => ({type: Types.ROLE_LIST_ACTION, filters});
export const dataRoleSuccess = (roles) => ({type: Types.ROLE_LIST_SUCCESS, roles});

export const dataAllRoleAction = () => ({type: Types.ROLE_LIST_ALL_ACTION});
export const dataAllRoleSuccess = (allRoles) => ({type: Types.ROLE_LIST_ALL_SUCCESS, allRoles});

export const dataRolePremissionAction = () => ({type: Types.ROLE_PERMISSION_LIST_ACTION});
export const dataRolePremissionSuccess = (permissions) => ({type: Types.ROLE_PERMISSION_LIST_SUCCESS, permissions});

export const getUpdateRoleAction = (params) => ({type: Types.ROLE_GET_UPDATE_ACTION, params});
export const getUpdateRoleSuccess = (dataUpdate) => ({type: Types.ROLE_GET_UPDATE_SUCCESS, dataUpdate});

export const createRoleAction = (params) => ({type: Types.ROLE_CREATE_ACTION, params});
export const deleteRoleAction = (params) => ({type: Types.ROLE_DELETE_ACTION, params});
export const updateRoleAction = (params) => ({type: Types.ROLE_UPDATE_ACTION, params});